import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import {
  ClickedNotificationEvent,
  ViewedNotificationEvent,
} from '@reverbdotcom/commons/src/elog/mparticle_types';
import { NotificationEventTrackingFieldsFragment } from '@reverbdotcom/commons/src/gql/graphql';

type NotificationEventPayload = Omit<ClickedNotificationEvent, 'eventName'>;

/** The two events differ only in name, so a field added to the fragment lands on both. */
function notificationEventPayload(
  eventTracking: NotificationEventTrackingFieldsFragment,
): NotificationEventPayload {
  return {
    notificationType: eventTracking.notificationType,
    notificationId: eventTracking.notificationId,
    name: eventTracking.name,
    position: eventTracking.position,
    listingId: eventTracking.listingId,
    cpId: eventTracking.cpId,
    discountAmountCents: eventTracking.discountAmountCents,
    discountAmountCurrency: eventTracking.discountAmountCurrency,
    discountPercent: eventTracking.discountPercent,
  };
}

export function clickedNotificationEvent(
  eventTracking: NotificationEventTrackingFieldsFragment,
): ClickedNotificationEvent {
  return {
    eventName: MParticleEventName.ClickedNotification,
    ...notificationEventPayload(eventTracking),
  };
}

export function viewedNotificationEvent(
  eventTracking: NotificationEventTrackingFieldsFragment,
): ViewedNotificationEvent {
  return {
    eventName: MParticleEventName.ViewedNotification,
    ...notificationEventPayload(eventTracking),
  };
}
